import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);

export default function BarChart({ data }) {
  const chartData = {
    labels: data.map((d) => d.period),
    datasets: [
      {
        label: "Total Klik",
        data: data.map((d) => d.total),
        backgroundColor: "#198754",
      },
    ],
  };

  return <Bar data={chartData} />;
}
